import { useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import ActivityTypes from '@/constants/ActivityTypes';

export default function useThemeActivitiesLinks({ themeActivities }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      activityGroups: [],
    },
    actions: {},
  });

  useEffect(() => {
    if (themeActivities) {
      const sortedGroupedActivities = ActivityTypes.typesOrdered.reduce(
        (acc, type) => {
          if (themeActivities.some((activity) => activity.type === type)) {
            let activitiesGroup = {
              type,
              activities: themeActivities.filter(
                (activity) => activity.type === type
              ),
            };
            acc.push(activitiesGroup);
          }
          return acc;
        },
        []
      );

      actions.setState({
        activityGroups: sortedGroupedActivities,
      });
    }
  }, [themeActivities]);

  return { state, actions };
}
